import Sections from './component';
import { SectionProps } from './types';

export default Sections;
export type { SectionProps };
